import React, { useState , useEffect} from "react";
import useResumeStore from "../../store/resume.store";
import { Steps } from "antd";
export default function CandidateInterviewHistory({jdID,rID}) {
   const [stepsArray, setStepsArray] = useState([]);
   const {selectedApplication} =
        useResumeStore();

  const GetHistoryDetails = (historyArray)=>{
    var tmpArray = []
    for(let idx = 0; idx < historyArray?.length; idx++){  
        var stepsItem ={'title':'','description':'','subTitle':''}
        stepsItem.title =  historyArray[idx].type +"  " + historyArray[idx].status  
        stepsItem.description =  " Updated By "+ historyArray[idx].updatedby.name + " [ "+  historyArray[idx].updatedby.updatedon + " ] "
        stepsItem.subTitle = historyArray[idx].interviewdate + ' ' + historyArray[idx].interviewtime
        tmpArray.push(stepsItem)
     }
     setStepsArray([...tmpArray])
   }    

   const interviewDetails = {
                name: selectedApplication?.applicationid.name,
                mobile: selectedApplication?.applicationid.mobile,
                email: selectedApplication?.applicationid.email,
                history: selectedApplication?.interviewhistory,
        }  

  useEffect(() => {
           GetHistoryDetails(interviewDetails?.history) 
  }, []);
     
  if (stepsArray?.length==0) return <>Details Not Found</>;
  
  return (
    <>
      <div className="candidate-interview-history-wrapper">
        <h5>Candidate Interview History</h5>
        <Steps
          progressDot
          current={stepsArray?.length-1}
          direction="vertical"
          items={stepsArray}
        />
      </div>
    </>
  );
}
